<template>
  <el-dialog :title="dialogType == 0? '添加标题': '修改标题'" :visible.sync='detailDialogVisible' width='700px' center @close="dialogClose">
    <div class='detail' >
      <el-form :model='changeData' >
        <el-form-item label='标题:'style="margin-left: 40px">
          <el-input v-model='changeData.title' size='mini' placeholder='请输入标题'  style="width: 500px"/>
        </el-form-item>
        <el-form-item style="margin-left: 250px">
          <el-button size='small' class='searchBtn' @click='submit'>确认</el-button>
          <el-button size='small' class='resetBtn' @click='dialogClose'>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { oilEdit} from "@/service/contract"

export default {
  data(){
    return{
      detailDialogVisible: false,
      detailLoading: false,
      dialogTitle: '',
      changeData: {
        title: '',
        id: ''
      },
      dialogType: '',
    }
  },
  methods: {
    dialogOpen(row,type) {
      this.changeData.id = row.id
      this.dialogType = type
      this.detailDialogVisible = true
    },
    async submit() {
      let obj = {
       title: this.changeData.title,
        id: this.changeData.id
      }
      const res = await oilEdit(obj)
      if (res.status !== 0) return this.$message.warning(res.message);
      this.$message.success(res.message);
      this.reset()
      this.dialogClose()
    },
    dialogClose(){
      this.detailDialogVisible = false
      this.reset()
    },
    reset(){
      this.changeData.title = ''
    }
  }
}
</script>

<style scoped lang="scss">

</style>
